<template>
	<div
		class="code-list-search__results"
		v-infinite-scroll="handleScroll"
		infinite-scroll-distance="50"
	>
		<ul ref="infiniteScrollList">
			<li
				class="code-list-search__results-item"
				v-for="code in source.items"
				:key="code.id"
				:id="code.id"
			>
				<a href="#" class="link" @click.prevent="clickHandler(code)">{{
					code.description
				}}</a>
			</li>
		</ul>
		<Spinner
			:processor="{ loading: loadingSource }"
			:variant="spinnerVariant"
		/>
		<div class="end-results" v-if="hasNoMoreRecords">
			End of results
		</div>
		<NoResults v-show="hasNoResults" />
	</div>
</template>

<script>
import Spinner from '@/components/visual/spinner/spinner';
import NoResults from '@/site-components/no-results/no-results';
import PaginationView from '@/mixins/infiniteScroll/view';
import { mapGetters } from 'vuex';

export default {
	name: 'CodesModalList',
	mixins: [PaginationView],
	components: {
		NoResults,
		Spinner
	},
	computed: {
		...mapGetters('loader', ['loading']),
		loadingSource() {
			return this.loading('get.snippets');
		}
	},
	methods: {
		clickHandler(code) {
			let copiedCode = { ...code };
			copiedCode.originalFormsSnippetId = copiedCode.id;
			copiedCode.description = `Copy Of ${copiedCode.id} ${copiedCode.description}`;
			copiedCode.sourceOfSelection = 'CopyOfListing';
			delete copiedCode['id'];
			this.$store.dispatch('codemanager/codeSelected', copiedCode);
			this.$emit('show', {
				showNewCodeModal: true,
				showCodeListModal: false
			});
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * [Description]
    * Code Manager Codes Modal
    * Can use SCSS variables = TRUE
	* BASE
*/

/*------------------------------------*\
  #BASE
\*------------------------------------*/
.code-list-search {
	&__results {
		font-size: $default-font-size - 2px;
		overflow: auto;
		max-height: calc(100vh - 190px); ///250
		@include scrollbar;
		padding-inline-start: 0;

		@include mq($from: md) {
			max-height: calc(87vh - 320px);
		}

		&-item {
			list-style: none;
			padding: $padding-md 0;
			word-break: break-all;

			&:first-child {
				padding-top: 0;
			}
		}
	}
}
</style>
